
















import { Component, Prop, Vue } from 'vue-property-decorator';
import OfferBadge from '@/views/product/common/OfferBadge.vue';
import { ProductPropertyDto } from '@/api';

@Component({
  components: {
    OfferBadge,
  },
})
export default class ProductDetailBadges extends Vue {
  @Prop({required: true})
  public isNew!: boolean;

  @Prop({required: true})
  public isLowPrice!: boolean;

  @Prop({required: true})
  public hasOfferPrice!: boolean;

  @Prop({required: false})
  public offerPercentage?: string;

  @Prop({required: true})
  public iconProperties!: ProductPropertyDto[];

  public getBadgeIconPath(productProperty: ProductPropertyDto) {
    try {
      return require(`@/assets/badges/${productProperty.toLowerCase()}.svg`);
    } catch (error) {
      return '';
    }
  }
}
